<template>
  <el-container
    v-loading.fullscreen.lock="loading">
  </el-container>
</template>

<script>
export default {
  name: 'Oauth',
  created() {
    if (!this.$route.query.code) {
      if (this.$store.getters['user/isAuthenticated']) {
        this.$router.push('/').catch(() => {});
      } else {
        this.$router.push('/login');
      }
    } else {
      this.$noauth
        .post(`/nrl/api/v1/admin/login?code=${this.$route.query.code}&manager=true`, {
        })
        .then((response) => {
          this.$store.commit('user/login', response.data);
          this.$router.push('/').catch(() => {});
        })
        .catch(() => {
          this.$customError('Not Authorized');
          this.$router.push('/login');
        });
    }
  },
  data() {
    return {
      loading: true,
    };
  },
};
</script>

<style scoped lang="scss">
</style>
